import React from "react";
import useWishlist from "../../userDashboard/wishlist/useWishlist";

function AbandonedWishlistComp() {
  const {
    abandonedWishlistData,
    isGettingAbandonedWishlist,
    isErrorGettingAbandonedWishlist,
  } = useWishlist();

  if (isGettingAbandonedWishlist) return <p>Loading abandoned wishlists...</p>;
  if (isErrorGettingAbandonedWishlist) return <p>Error loading data.</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
        Abandoned Wishlist
      </h1>{" "}
      {abandonedWishlistData.length > 0 ? (
        abandonedWishlistData?.map((item, index) => (
          <div
            key={index}
            className="p-4 border rounded-lg shadow-sm bg-white flex flex-col gap-3"
          >
            {/* Product Info */}
            <div className="flex items-start gap-4">
              <img
                src={item.product?.photo}
                alt={item.product?.name}
                className="w-24 h-24 object-cover rounded-md"
              />
              <div>
                <h2 className="text-lg font-semibold">{item.product?.name}</h2>
                <p className="text-gray-600 text-sm line-clamp-2">
                  {item.product?.description}
                </p>
                <p className="text-sm text-gray-700 mt-1">
                  <span className="font-medium">Price:</span> ₹
                  {item.product?.price.toLocaleString()}
                </p>
              </div>
            </div>

            {/* Meta Info */}
            <div className="text-sm text-gray-700 flex flex-wrap gap-4">
              <span>
                <span className="font-medium">In Stock:</span>{" "}
                {item.inStock ? "Yes" : "No"}
              </span>
              <span>
                <span className="font-medium">Sold:</span> {item.product?.sold}
              </span>
              <span>
                <span className="font-medium">Avg. Abandoned Days:</span>{" "}
                {item.avgAbandonedDays}
              </span>
              <span>
                <span className="font-medium">Abandoned By:</span>{" "}
                {item.abandonedByCount} user(s)
              </span>
              <span>
                <span className="font-medium">Pending Notifications:</span>{" "}
                {item.pendingNotificationCount}
              </span>
              <span>
                <span className="font-medium">All Users Notified:</span>{" "}
                {item.allUsersNotified ? "Yes" : "No"}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-12 text-gray-500">
          No Abandoned wishlist found.
        </div>
      )}
    </div>
  );
}

export default AbandonedWishlistComp;
